import React from 'react';
import { css } from 'aphrodite';
import styles from './login-styles';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import { Switch, FilledGreenButton } from '../common';
import { NavLink } from 'react-router-dom';

const LoginView = (props) => (
  <div className={css(styles.root)}>

    <h1 className={css(styles.title)}>
      Login
    </h1>

    <div className={css(styles.description)}>
      We can pickup anything you want, and deliver to your customers
    </div>

    <div className={css(styles.content)}>
      <div style={{ position: 'relative' }}>
        <div className={css(styles.inputIconContainer)}><FaEnvelope className={css(styles.inputIcon)} /></div>
        <input placeholder={'email'} type={'email'} className={css(styles.input)} value={props.email} onChange={props.onChangeEmail} />
      </div>
      <div style={{ position: 'relative' }}>
        <div className={css(styles.inputIconContainer)}><FaLock className={css(styles.inputIcon)} /></div>
        <input placeholder={'password'} type={'password'} className={css(styles.input)} value={props.password}
          onKeyDown={props.handleKeyDown}
          onChange={props.onChangePassword} />
      </div>

      <div className={css(styles.rememberMeContainer)}>
        <Switch checked={props.rememberMe} onChange={props.toggleRememberMe} />
        <div className={css(styles.rememberMeText)}>Remember me</div>
      </div>


      <FilledGreenButton disabled={props.disabled} title={'Login'} onClick={props.login} loading={props.loading} />

    </div>

    <NavLink to={'/reset-password'} className={css(styles.forgottenPasswordLink)}>
      Forgot password?
    </NavLink>

  </div>
);

export default LoginView;



// WEBPACK FOOTER //
// ./src/components/login/login-view.js